import { FormGroup, Input, TextArea } from '@agro-club/agroclub-shared'
import { FormikProps } from 'formik'
import { endpoints } from 'modules/endpoints'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormEnumSelect } from 'views/components/form/EnumSelect/FormEnumSelect'
import { FormSelectButton } from 'views/components/FormSelectButtons/FormSelectButtons'
import FormSelectShared from 'views/components/FormSelectShared'
import { SharedModalInputs } from 'views/components/SharedModal'
import { SharedModalContent } from 'views/components/SharedModal/styled'
import { RailCarType } from '../../types'
import { AddCarOwnerModal } from './AddCarOwnerModal'
import { FormDatePicker } from 'views/components/form/FormDatePicker'
import { ShortFormControl } from 'views/styled/common'
import { rubPerTon } from 'modules/utils/numbers/formatTarif'

interface Props {
  formik: FormikProps<any>
  isAverageRates?: boolean
  isEdit?: boolean
}
export const RailsModalContent: FC<Props> = ({ formik, isEdit }) => {
  const { t } = useTranslation('rates')
  const [ownerModalOpen, setOwnerModalOpen] = useState(false)

  return (
    <SharedModalContent>
      <SharedModalInputs>
        <FormSelectShared
          label={t('fromStation')}
          formik={formik}
          fieldName="from_station"
          getLabel={(station) => `${station.title} (${station.station_code})`}
          endpoint={endpoints.LogisticsKR.railwayStations()}
          searchField="search"
          placeholder=""
          disabled={isEdit}
        />

        <FormSelectShared
          label={t('toStation')}
          formik={formik}
          fieldName="to_station"
          getLabel={(station) => `${station.title} (${station.station_code})`}
          endpoint={endpoints.LogisticsKR.railwayStations()}
          searchField="search"
          placeholder=""
          disabled={isEdit}
        />
        <FormSelectShared
          label={t('common:product')}
          formik={formik}
          endpoint={`${endpoints.LogisticsKR.products()}?is_etsng_parent=true`}
          getLabel={(dto) => dto.name}
          fieldName="product"
        />
        <FormSelectShared
          endpoint={endpoints.LogisticsKR.railCarOwners()}
          placeholder={''}
          getLabel={(dto) => dto.name}
          label={t('rail_car_owner')}
          fieldName="rail_car_owner"
          formik={formik}
          searchField="search"
        >
          <FormSelectButton action={() => setOwnerModalOpen(true)} eventId="addOwner" />
        </FormSelectShared>
        <FormEnumSelect
          translationNameSpace={'rates:railCarTypes'}
          fieldName="rail_car_type"
          enumType={RailCarType}
          label={t('rail_car_type')}
          formik={formik}
          allowClear
        />
        <ShortFormControl>
          <FormGroup label={rubPerTon(t('rate'))} error={formik.errors.rate}>
            <Input {...formik.getFieldProps('rate')} invalid={!!formik.errors.rate} type="number" />
          </FormGroup>
        </ShortFormControl>
        <FormDatePicker
          label={t('start_date')}
          fieldName="start_date"
          id="start_date"
          formik={formik}
          size="small"
          short={false}
        />
        <FormDatePicker
          label={t('end_date')}
          fieldName="end_date"
          id="end_date"
          formik={formik}
          size="small"
          short={false}
        />
        <FormGroup label={t('rail_car_load_limit')} error={formik.errors.rail_car_load_limit}>
          <Input
            {...formik.getFieldProps('rail_car_load_limit')}
            invalid={!!formik.errors.rail_car_load_limit}
            type="number"
          />
        </FormGroup>
        <FormGroup error={formik.errors.comment} label={t('common:comments')}>
          <TextArea {...formik.getFieldProps('comment')} invalid={!!formik.errors.comment} height={80} />
        </FormGroup>
      </SharedModalInputs>
      {ownerModalOpen && (
        <AddCarOwnerModal
          onClose={() => setOwnerModalOpen(false)}
          onSuccess={(createdId) => {
            formik.setFieldValue('rail_car_owner', createdId)
          }}
        />
      )}
    </SharedModalContent>
  )
}
